import type { OpeningSearchParams } from './types';

/** Backend route builders (paths only — prefix with the API base URL). */
export const API_ROUTES = {
  // Auth
  authRegister: '/auth/register',
  authLogin: '/auth/login',
  authRefresh: '/auth/refresh',
  authLogout: '/auth/logout',

  // Openings (public — browsing and reading theory never requires an account)
  openings: '/openings',
  openingFilters: '/openings/filters',
  opening: (id: string) => `/openings/${encodeURIComponent(id)}`,
  openingLine: (openingId: string, lineId: string) =>
    `/openings/${encodeURIComponent(openingId)}/lines/${encodeURIComponent(lineId)}`,

  // Repertoire (auth)
  pathway: '/pathway',
  repertoire: '/repertoire',
  repertoireEntry: (openingId: string) => `/repertoire/${encodeURIComponent(openingId)}`,

  // Study (auth)
  studyHome: '/study/home',
  studyQueue: '/study/queue',
  studyReview: '/study/review',
  studyStats: '/study/stats',

  // Settings (auth)
  settings: '/settings',

  // Coach — LLM explanations, disabled unless COACH_ENABLED is set (auth)
  coachExplain: '/coach/explain',
} as const;

/** Build the query string for GET /openings. Multi-value filters are CSV. */
export function buildOpeningsQuery(params: OpeningSearchParams): string {
  const q = new URLSearchParams();
  if (params.search) q.set('search', params.search);
  const csv = (key: string, vals?: (string | number)[]) => {
    if (vals && vals.length) q.set(key, vals.join(','));
  };
  csv('families', params.families);
  csv('sides', params.sides);
  csv('difficulties', params.difficulties);
  csv('tiers', params.tiers);
  csv('tags', params.tags);
  if (params.page != null) q.set('page', String(params.page));
  if (params.pageSize != null) q.set('pageSize', String(params.pageSize));
  if (params.sort) q.set('sort', params.sort);
  const s = q.toString();
  return s ? `?${s}` : '';
}
